import { Button, Inline } from 'canoe';
import React from 'react';

import { Flags, useFlags, useNavigation } from 'commons/hooks';
import { CONTENT_PATH } from 'dashboard/pages/Content/constants';
import { CREATE_ROUTE } from 'dashboard/pages/Content/pages/Create/constants';
import { GENERATE_CONTENT_ROUTE } from 'dashboard/pages/Content/pages/Generate';

export const CreateContent = () => {
  const {
    [Flags.FIRST_MATE]: withFirstMate,
    [Flags.FIRST_MATE_CREATE_CONTENT]: withCreateContent,
  } = useFlags();

  const navigate = useNavigation();
  return (
    <Inline>
      {withFirstMate && withCreateContent && (
        <Button
          id="create-content-with-ai"
          onClick={() => navigate(`${CONTENT_PATH}/${GENERATE_CONTENT_ROUTE.path}`)}
          color="primary"
          appearance="outline"
          size="lg"
        >
          Generate with AI
        </Button>
      )}
      <Button
        id="create-content"
        onClick={() => navigate(`${CONTENT_PATH}/${CREATE_ROUTE.path}`)}
        color="primary"
        size="lg"
      >
        Create New Content
      </Button>
    </Inline>
  );
};

export default CreateContent;
